import React, { SyntheticEvent, useContext, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { GlobalContext } from "../Utils/Contexts";
import { PersonExtended } from "../Utils/TypeExtensions";
import CancelIcon from "@mui/icons-material/Cancel";
import OkIcon from "@mui/icons-material/Done";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../Utils/TicketDatabase";

export default function ProxyPilotDialog(): JSX.Element {
    const context = useContext(GlobalContext);

    const [selected, setSelected] = useState<PersonExtended>();

    const pilotList = useLiveQuery(async () => TicketDatabase.pilot.toArray());

    if (!pilotList) return <></>;

    function cancelProxy() {
        context.toggleDemoMode(context, false); // we are cancelling picking a pilot, so leave demo mode
        context.setShowProxyPilotDialogue(false);
    }

    function setProxy() {
        context.setShowProxyPilotDialogue(false, selected);
    }

    const sortedNames = pilotList.sort((a: PersonExtended, b: PersonExtended) => {
        return (a.selectName ?? "").localeCompare(b.selectName ?? "");
    });

    function handleOnChange(e: SyntheticEvent, value: string | PersonExtended | null) {
        let newValue = undefined;
        if (typeof value === "object") {
            newValue = value as PersonExtended;
        }

        setSelected(newValue);
    }

    return (
        <Dialog open onClose={cancelProxy} fullWidth={true}>
            <DialogTitle>SELECT A PILOT TO USE FOR DEMO MODE</DialogTitle>
            <DialogContent>
                <Box sx={{ border: "1px solid lightgrey", borderRadius: 3, p: 3 }}>
                    <Autocomplete
                        value={selected ?? null}
                        options={sortedNames}
                        onChange={handleOnChange}
                        getOptionLabel={(option: PersonExtended) => option.selectName ?? ""}
                        filterSelectedOptions
                        renderInput={(params) => <TextField {...params} margin="dense" label="PILOT" placeholder="type to search" />}
                    />
                </Box>
            </DialogContent>

            <DialogActions style={{ justifyContent: "space-between" }}>
                <Button sx={{ margin: 2 }} variant="contained" startIcon={<CancelIcon />} color="secondary" onClick={cancelProxy}>
                    CANCEL
                </Button>
                <Button sx={{ margin: 2 }} variant="contained" startIcon={<OkIcon />} color="secondary" disabled={selected === null || selected === undefined} onClick={setProxy}>
                    DEMO
                </Button>
            </DialogActions>
        </Dialog>
    );
}
